module.exports = __webpack_public_path__ + "static/media/audio-description.359367e6.svg";